import { createSlice } from '@reduxjs/toolkit';
import {
  getAllCustomFail,
  getAllCustomPending,
  getAllCustomSuccess,
  INITIAL_STATE_CUSTOM,
  resetResourceDataCustom,
} from 'redux/crudCreatorCustom/utils';
import { getProvidersOfCompany } from './actions';

export const initialState = {
  ...INITIAL_STATE_CUSTOM,
};

const { actions, reducer } = createSlice({
  name: 'providersOfCompany',
  initialState,
  reducers: {
    resetResourceFilterProvidersOfCompany: resetResourceDataCustom,
  },
  extraReducers: {
    [getProvidersOfCompany.pending]: getAllCustomPending,
    [getProvidersOfCompany.fulfilled]: getAllCustomSuccess,
    [getProvidersOfCompany.rejected]: getAllCustomFail,
  },
});

export const { resetResourceFilterProvidersOfCompany } = actions;

export default reducer;
